import {
    BLACKSMELLYWATERGOVERMENT} from 'actions/pzCustom/blackSmellyWaterGoverment';
  export const initialState = {
    isFetching: false,
    data: []
  };
  export const blackSmellyWaterGovermentList = (state = initialState, action) => {
    switch (action.type) {
      case `${BLACKSMELLYWATERGOVERMENT}_PENDING`:
        return Object.assign({}, initialState,{
          isFetching:true
        });
      case `${BLACKSMELLYWATERGOVERMENT}_SUCCESS`:
        return Object.assign({}, state, {
          isFetching: false,
          data: action.payload.data,
          allData:action.payload
        });
      default:
        return state;
    }
  };
  
  